import {
  useMutationApi,
  MutationApiOptions,
  MutationApiResult,
} from '~/libs/api-hooks/architect';

interface UseSendServerSidePageEventProps {
  reactQueryOptions?: MutationApiOptions<
    undefined,
    SendServerSidePageEventMutatorProps
  >;
}

interface SendServerSidePageEventMutatorProps {
  userAnalyticsId: string;
  pageName: string;
  properties: {
    [property: string]: string | boolean | number | null;
  };
}

export const mutatorRequester = ({
  userAnalyticsId,
  pageName,
  properties,
}: SendServerSidePageEventMutatorProps) => ({
  body: {
    userAnalyticsId,
    pageName,
    properties,
  },
});

/**
 * API Hook to send a page viewed event
 * @endpoint `/private/experiments/e`
 * @service (Growth-Analytics)
 */

const useSendServerSidePageEvent = ({
  reactQueryOptions,
}: UseSendServerSidePageEventProps = {}): MutationApiResult<
  undefined,
  SendServerSidePageEventMutatorProps
> => {
  const pathname = '/private/experiments/p';
  const method = 'POST';
  const mutationKey = ['private', 'experiments', 'p'];

  return useMutationApi<undefined, SendServerSidePageEventMutatorProps>({
    pathname,
    mutationKey,
    method,
    reactQueryOptions,
    includeApiKeyWhenAvailable: false,
    sendCsrfToken: false,
    mutatorRequester,
    urlOptions: { subdomain: 'app' },
  });
};

export default useSendServerSidePageEvent;
